<template>
  <div>
    <!-- 搜索部分 -->
    <div class="table-container">
      
      <el-button style="margin-bottom: 8px" @click="add_coupon({})">
        添加优惠劵
      </el-button>
      <el-table ref="tableSort" v-loading="listLoading" :data="list" element-loading-text="加载中" :height="height"
        style="width: 100%" border @selection-change="setSelectRows">
        <el-table-column prop="title" align="center" label="优惠劵名称"></el-table-column>
        <el-table-column prop="money" align="center" label="优惠劵面值"></el-table-column>
        <el-table-column prop="at_least" align="center" label="最低使用金额"></el-table-column>
        <el-table-column prop="count" align="center" label="单用用户可领"></el-table-column>
        <el-table-column label="操作面板" width="250px" fixed="right" align="center">
          <template #default="{ row }">
            <el-button size="mini" type="text" @click="add_coupon(row)">
              编辑
            </el-button>
            <el-button size="mini" type="text" style="color: red" @click="del_coupon(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="queryForm.page" :layout="layout" :page-sizes="[20, 40, 60, 100]"
        :page-size="queryForm.limit" :total="total" @current-change="handleCurrentChange"
        @size-change="handleSizeChange"></el-pagination>
    </div>
    <couponEdit ref="edit" @saves="save_change"></couponEdit>
  </div>
</template>

<script>
  import {
    coupon_add,
    coupon_list,
    coupon_detail,
    coupon_update,
    coupon_del,
  } from '@/api/coupon'
  import couponEdit from './coupon_edit.vue'
  import exoprt_file from '@/utils/expor_file' // 导出excel文件
  export default {
    components: {
      couponEdit,
    },
    filters: {},
    data() {
      return {
        listLoading: true,
        SelectRows: [],
        list: [],
        queryForm: {
          page: 1,
          limit: 10,
          kor_type: 0,
        },
        total: 0,
        height: '70vh',
        layout: 'total, sizes, prev, pager, next, jumper',
      }
    },
    mounted() {
      this.fetchData()
    },
    methods: {
      del_coupon(row) {
        // 删除优惠劵
        this.listLoading = true
        this.$confirm('此操作将永久删除该优惠劵, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(() => {
            var data = {
              id: row.id,
            }
            coupon_del(data).then((res) => {
              this.$message({
                type: 'success',
                message: '删除成功!',
              })
              this.listLoading = false
              this.fetchData()
            })
          })
          .catch(() => {
            this.listLoading = false
            this.$message({
              type: 'info',
              message: '已取消删除',
            })
          })
      },
      add_coupon(e) {
        // 添加修改优惠劵
        this.listLoading = true
        this.$refs['edit'].show_edit(e)
      },
      save_change(e) {
        // 添加修改
        this.listLoading = false
        if (e == 'success') {
          // 成功刷新列表
          this.fetchData()
        }
      },
      fetchData() {
        // 优惠劵列表
        var data = {
          ...this.queryForm,
        }
        this.listLoading = true
        coupon_list(data)
          .then((res) => {
            this.list = res.data.list
            this.listLoading = false
            this.total = res.data.count
          })
          .catch((err) => {
            this.listLoading = false
          })
      },
      setSelectRows(e) {
        // 列表选中
        this.SelectRows = e
      },
      handleSizeChange(e) {
        // 分页
        this.queryForm.limit = e
        this.queryForm.page = 1
        this.fetchData()
      },
      handleCurrentChange(e) {
        // 分页
        this.queryForm.page = e
        this.fetchData()
      },
    },
  }
</script>

<style scoped>
  :deep .el-button--mini {
    padding: 5px 11px;
  }

  :deep .right-panel {
    display: flex;
    align-items: center;
  }

  .demo-tabs .custom-tabs-label span {
    vertical-align: super;
    margin-left: 4px;
  }

  ::v-deep(.el-badge__content.is-fixed) {
    top: 11px;
    right: 17px;
  }

  .table-container {
    padding: 15px;
    padding-top: 30px;
    box-sizing: border-box;
    border-left: 1px solid #e4e7ed;
    border-right: 1px solid #e4e7ed;
    border-bottom: 1px solid #e4e7ed;
  }

  .el-tabs__item {
    width: 200px;
    /* 设置宽度为200px */
  }

  .el-badge {
    width: 60px !important;
  }

  ::v-deep(.el-tabs__header) {
    margin: 0 !important;
  }

  ::v-deep(.el-tabs__header span) {
    font-weight: bold;
  }

  .demo-table-expand {
    font-size: 0;
    padding-left: 150px;
    box-sizing: border-box;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 30%;
  }

  .dabaoStyle {
    background: #ffddaa;
    color: #999;
    border: 1px solid #fd5;
  }

  .fahuoStyle {
    background: #99dddd;
    color: #999;
    border: 1px solid 00FFFF;
  }

  .zhuanyunStyle {
    background: #ffffaa;
    color: #999;
    border: 1px solid FFFF00;
  }
</style>
